// extracted by mini-css-extract-plugin
module.exports = {"root":"bd_bJ","body":"bd_G"};